module.exports = __webpack_public_path__ + "static/media/drinks.e1a63069.jpg";